/**
 * Enum used by planners when "showMeasurementSystemSwitch" is true to allow users to switch between metric and imperial (controlled by planner).
 */
var MeasurementSystemEnum;
(function (MeasurementSystemEnum) {
    MeasurementSystemEnum["metric"] = "metric";
    MeasurementSystemEnum["imperial"] = "imperial";
})(MeasurementSystemEnum || (MeasurementSystemEnum = {}));
export default MeasurementSystemEnum;
//# sourceMappingURL=MeasurementSystemEnum.js.map